module.exports = __webpack_public_path__ + "img/7.0ec0d01f.png";